// extracted by mini-css-extract-plugin
export var legendIndicator = "_dd-1";
export var legendRight = "_dd-0";